import axios from "axios";

// Park Details
const parkDetailsEndpoint = (parkToUse: string) =>
  `/jsonData/${parkToUse.toUpperCase()}/PARK_DETAILS.json`;

export const callParkDetailsEndpoint = (park: string) =>
  axios.get(parkDetailsEndpoint(park)).then((res) => res.data);

// Area Listing
const areaListingEndpoint = () => "/jsonData/AREA_LISTING.json";

export const callAreaListingEndpoint = () =>
  axios.get(areaListingEndpoint()).then((res) => res.data);

// Caravan Details
const caravanDetailsEndpoint = (park: string, caravan: string) =>
  `/jsonData/${(park as string).toUpperCase()}/${caravan}.json`;

export const callCaravanDetailsEndpoint = (park: string, caravan: string) =>
  axios.get(caravanDetailsEndpoint(park, caravan)).then((res) => res.data);

// Park Stock
const parkStockEndpoint = (park: string) =>
  `/jsonData/${(park as string).toUpperCase()}/STOCK.json`;

export const callParkStockEndpoint = (park: string) =>
  axios.get(parkStockEndpoint(park)).then((res) => res.data);

// Operators
const operatorEndpoint = () => '/jsonData/OPERATOR.json';

export const callOperatorEndpoint = () =>
  axios.get(operatorEndpoint()).then((res) => res.data);

// Version
const versionEndpoint = () => '/jsonData/VERSION.json';

export const callVersionEndpoint = () =>
  axios.get(versionEndpoint()).then((res) => res.data);
